import React from 'react'
import "./single.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import ProductChart from "../../components/chart/AreaChart/productAreaChart";

import { Link } from 'react-router-dom';

import { useEffect as uEffect, useState as uState } from "react";
import { useParams as uParams } from "react-router-dom";

export default function singleProduct() {
    const { productId } = uParams();

    const  upProdId  = productId

    // const productIdAsString = productId.toString();

    const [product, setProduct] = uState(null);

    uEffect(() => {
        fetch("http://localhost:8000/products/oneProduct", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ idToFound: productId }),
        }).then(async (res) => {
            let response = await res.json()
            setProduct(response)
        })
    }, [productId]);  
  return (
      <>
          <div className="single">
              <Sidebar />
              <div className="singleContainer">
                  <Navbar />
                  {product ? (
                      <div className="top">
                          <div className="left">
                              <div className="editButton"><Link to={`${upProdId}`}>Edit</Link></div>
                              <h1 className="title">Information</h1>
                              <div className="item">
                                  <img className='itemImg' src={product.imageUrl ? `http://localhost:8000/public/${product.imageUrl}` : product.productImage} alt="" />
                                  <div className="details">
                                      <h1 className="itemTitle">{product.productTitle || 'no data'}</h1>
                                      <div className="detailItem">
                                          <span className="itemKey">Type:</span>
                                          <span className="itemValue">{product.productType}</span>
                                      </div>
                                      <div className="detailItem">
                                          <span className="itemKey">Quantity:</span>
                                          <span className="itemValue">{product.productQuantity}mg</span>
                                      </div>
                                      <div className="detailItem">
                                          <span className="itemKey">Amount:</span>
                                          <span className="itemValue">₹{product.productAmount}</span>
                                      </div>
                                      <div className="detailItem">
                                          <span className="itemKey">Description:</span>
                                          <span className="itemValue">{product.productDescription}</span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className="right">
                              <ProductChart aspect={2 / 1} title="Product Sold ( Last 6 Months)" />
                          </div>
                      </div>
                  ) : (
                      <div>Loading...</div>
                  )}
              </div>
          </div>
      
      
      </>
  )
}
